import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import "./index.scss";

export default function Footer() {
  return (
    <AppBar
      elevation={0}
      position="fixed"
      color="primary"
      sx={{ top: "auto", bottom: 0 }}
    >
      <Toolbar variant="dense">
        <Typography variant="small" component="div" sx={{ flexGrow: 1 }}>
          Flotek {new Date().getFullYear()} All Rights Reserved
        </Typography>
      </Toolbar>
    </AppBar>
  );
}
